enum BorrowerCategoryEnum {
    Borrower = 'BORROWER',
    Guarantor = 'GUARANTOR',
    Trustee = 'TRUSTEE',
}

export default BorrowerCategoryEnum;
